// import axios from "axios";
// export default axios.create({
//   //prod server
//   baseURL: "http://149.56.26.231:8082/gateway",
//   headers: {
//     "Content-type": "application/json",
//   },
// });
import axios from "axios";
export default axios.create({
  //prod server
  baseURL: "http://149.56.30.111:8182/gateway",
  headers: {
    "Content-type": "application/json",
  },
});
// import axios from "axios";
// export default axios.create({
//   //prod server
//   baseURL: "http://144.217.66.144:8182/gateway",
//   headers: {
//     "Content-type": "application/json",
//   },
// });
